import { getInstance } from './Auth0'

export default class FileUploader {
  /**
   * Create new upload instance.
   *
   * @param {Object} files
   */
  constructor (files = []) {
    this.FormData = new FormData()

    if (files.length) {
      this.batch(files)
    }
  }

  /**
   * Add multiple files to be uploaded.
   *
   * @param {Object} files
   */
  batch (files) {
    [].forEach.call(files, this.add.bind(this))
  }

  /**
   * Add file to the upload.
   *
   * @param {object} file
   */
  add (file) {
    this.FormData.append(file.name, file, file.name)
  }

  /**
   * Perform the upload.
   *
   * @param {string} url
   * @return {Promise}
   */
  async send (url) {
    const token = await getInstance().getTokenSilently()

    return new Promise((resolve, reject) => {
      this.xhr = new XMLHttpRequest()
      this.xhr.responseType = 'json'
      this.xhr.open('POST', url, true)
      this.xhr.setRequestHeader('Authorization', `Bearer ${token}`)
      this.xhr.onloadend = (response) => {
        resolve(response)
      }
      this.xhr.onerror = (response) => {
        reject(response)
      }
      this.xhr.send(this.FormData)
    })
  }
}
